import { useEffect, useState } from "react";
import { getProcessSteps, ProcessStepData } from "../../contentfulService";

export default function ProcessSteps() {
    const [steps, setSteps] = useState<ProcessStepData[]>([]);

    useEffect(() => {
        getProcessSteps().then((data) => {
            const sorted = [...data].sort((a, b) => a.order - b.order);
            setSteps(sorted);
        });
    }, []);

    if (!steps.length) return null;

    return (
        <section id="processsteps" className="py-24 mx-auto px-8">
            <h2 className="text-4xl font-serif text-center pb-14">
                Lieferkette & Prozess
            </h2>
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
                    {steps.map((step, index) => {
                        const iconUrl = step.icon?.fields?.file?.url;

                        return (
                            <div
                                key={step.order}
                                className="relative flex flex-col text-left"
                            >
                                {/* ICON + TITLE */}
                                <div className="flex items-center gap-3 mb-3">
                                    {/* ICON */}
                                    <div className="w-6 h-6 flex items-center justify-center">
                                        {iconUrl ? (
                                            <img
                                                src={`https:${iconUrl}`}
                                                alt={step.icon?.fields?.title ?? step.name}
                                                className="w-5 h-5"
                                            />
                                        ) : (
                                            <div className="w-5 h-5 border border-gray-300 opacity-40" />
                                        )}
                                    </div>

                                    {/* TITLE */}
                                    <h3 className="font-medium tracking-wide text-textPrimary">
                                        {step.name}
                                    </h3>
                                </div>

                                {/* DESCRIPTION */}
                                <p className="text-textBody leading-relaxed w-full md:max-w-[240px]">
                                    {step.description}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
